export const validationToColumns: any = {
  'base_vehicle': [
    'year',
    'make',
    'model'
  ],
  'wheel_base': [
    'wheel_base_in',
    'wheel_base_mt'
  ],
  'engine_base': [
    'engine_liter',
    'engine_cc',
    'engine_cid',
    'engine_block_type',
    'engine_cylinder',
    'engine_bore_in',
    'engine_bore_mt',
    'engine_stroke_in',
    'engine_stroke_mt'
  ],
  'bed_length': [
    'bed_length_in',
    'bed_length_mt'
  ],
  'body_num_door': [
    'body_number_doors'
  ],
  'power_output': [
    'horse_power',
    'kilowatt_power'
  ]
};
